module.exports = __webpack_public_path__ + "assets/img/facergt-app3.1191210b.png";